import { useEffect, useRef, useState } from "react";

import {
  Box,
  Button,
  Card,
  Group,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { PlusCircle } from "~/../../base-components/lib/assets/icons/HDS";
import { ColorSchemeMode } from "~/../../base-components/lib/theme/ColorSchemeContext";
import {
  OUTLINE_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from "~/../../base-components/lib/theme/button";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "~/../../shared-features/lib/features/auth/hooks";
import { AppSEO } from "~/../../shared-features/lib/features/layout";

import { TOOLS_URL } from "config";

import DashboardContent from "../dashboard/DashboardContent";

import { Curation, useMockServer } from "./builder/_mock";

export const CurationsDashboard = () => {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { createNewCuration, listCurations, cloneCuration, deleteCuration } =
    useMockServer();
  const [curations, setCurations] = useState<Curation[]>([]);
  const [creatingCuration, setCreatingCuration] = useState(false);
  const enableCuratedSpacesPreview = useFeatureFlags(
    FEATURE_FLAGS.CURATED_SPACES_PREVIEW
  );

  // Load curations
  const listCurationsLoading = useRef(false);
  const loadCurations = async () => {
    try {
      listCurationsLoading.current = true;
      const curations = await listCurations();
      setCurations(curations);
      console.log("Curations", curations);
    } catch (error) {
      console.error("Error loading curations", error);
    } finally {
      listCurationsLoading.current = false;
    }
  };

  useEffect(() => {
    if (enableCuratedSpacesPreview && listCurationsLoading.current === false) {
      loadCurations();
    }
  }, [enableCuratedSpacesPreview]);

  const handleCreateNewCuration = async () => {
    try {
      console.log("Create new curation");
      setCreatingCuration(true);
      const draft = await createNewCuration();
      console.log("Draft", draft);
      navigate(TOOLS_URL.curations.edit.replace(":curationId", draft.id));
    } catch (error) {
      console.error("Error creating curation", error);
    } finally {
      setCreatingCuration(false);
    }
  };

  if (enableCuratedSpacesPreview === false) {
    return (
      <DashboardContent>
        <AppSEO title="Collections" />
        <Stack spacing="xl">
          <Box>Curated Spaces are coming soon!</Box>
        </Stack>
      </DashboardContent>
    );
  }

  return (
    <DashboardContent
      header={
        <Group>
          {/* <Button
            component={Link}
            color={
              theme.colorScheme === ColorSchemeMode.LIGHT
                ? PRIMARY_COLOR
                : OUTLINE_COLOR
            }
            to={TOOLS_URL.curations.create}
            leftIcon={<PlusCircle />}
          >
            Create a curation
          </Button> */}
          <Button
            color={
              theme.colorScheme === ColorSchemeMode.LIGHT
                ? PRIMARY_COLOR
                : OUTLINE_COLOR
            }
            onClick={handleCreateNewCuration}
            leftIcon={<PlusCircle />}
            loading={creatingCuration}
          >
            Create a curation
          </Button>
        </Group>
      }
    >
      <AppSEO title="Curations" />
      <Stack spacing="xl">
        {curations.map((curation) => (
          <Box key={curation.id}>
            <Card>
              <Group position="apart">
                <Text fw={500}>{curation.name}</Text>
                <Group>
                  <Button
                    color={PRIMARY_COLOR}
                    component="a"
                    href={
                      "/tools" +
                      TOOLS_URL.curations.edit.replace(
                        ":curationId",
                        curation.id
                      )
                    }
                    target="_blank"
                  >
                    Edit
                  </Button>

                  <Button
                    color={OUTLINE_COLOR}
                    component="a"
                    href={
                      "/tools" +
                      TOOLS_URL.curations.preview.replace(
                        ":curationId",
                        curation.id
                      )
                    }
                    target="_blank"
                  >
                    Preview
                  </Button>

                  <Button
                    color={SECONDARY_COLOR}
                    onClick={async () => {
                      await cloneCuration(curation.id);
                      loadCurations();
                    }}
                  >
                    Clone
                  </Button>

                  <Button
                    color={SECONDARY_COLOR}
                    onClick={async () => {
                      await deleteCuration(curation.id);
                      loadCurations();
                    }}
                  >
                    Delete
                  </Button>
                </Group>
              </Group>
            </Card>
          </Box>
        ))}
      </Stack>
    </DashboardContent>
  );
};
